import { fabric } from 'fabric';

import { INCH_QUOTE } from '~/core/constants';
import {
  hasShapeMeasureLabel,
  isBacksplashMeasureLabel,
  isCornerRadiusArc,
  isDiagonalCorner,
  isShapeEdge,
  isShapeLabel,
} from '~/core/utils';
import theme from '~/theme/theme';

const {
  drawingTool: {
    drawingShape: { stroke },
  },
} = theme.light;

export const setItemNameAndColors = (item: fabric.Object) => {
  item.set({ stroke: stroke.normal });
  if (isShapeLabel(item)) {
    item.set({ fill: stroke.normal });
  }

  if (hasShapeMeasureLabel(item)) {
    item.name = `${item.data.value}${INCH_QUOTE}`;
  }

  if (isBacksplashMeasureLabel(item)) {
    item.name = `   ${item.data.value}${INCH_QUOTE}`;
  }

  if (isShapeEdge(item)) {
    item.set({ stroke: stroke.normal });
  }

  if (isCornerRadiusArc(item)) {
    item.set({ stroke: stroke.normal });
  }

  if (isDiagonalCorner(item)) {
    item.set({ stroke: stroke.normal });
  }
};
